import type React from 'react';

import { BackgroundBranding } from '@/layouts/BackgroundBranding.comp.tsx';
import { DRAWER_WIDTH } from '@/layouts/private/Layout.tsx';
import { useIsMobile } from '@/layouts/private/sidebar/hooks/useResponsiveSideBar.ts';
import SideBar from '@/layouts/private/sidebar/SideBar.comp';
import { COLLAPSED_DRAWER_WIDTH } from '@/layouts/private/sidebar/SideBar.styles.ts';
import { TopBar } from '@/layouts/private/topBar/TopBar.comp.tsx';
import { LayoutShell } from '@/routes/LayoutShell.comp.tsx';

/**
 * Full-skeleton layout group (OCD-308): sidebar, topbar, branded background,
 * and the scrollable content container. Chrome is present because of route
 * structure — bare screens live under BareLayout instead of pathname checks.
 */
export const AppLayout: React.FC = () => {
  const isMobile = useIsMobile();
  const contentOffset = isMobile ? COLLAPSED_DRAWER_WIDTH : DRAWER_WIDTH;

  return (
    <>
      <BackgroundBranding />
      <LayoutShell marginLeft={contentOffset} sidebar={<SideBar />} topBar={<TopBar />} />
    </>
  );
};
